import React, {useEffect, useMemo, useState} from 'react';
import LoadingIcon from "../../../../../../../../../../../../../../Assets/Icons/circular-determinate.svg";
import DetectFaces from "../../../../../../../../../../../../../../Assets/Icons/AI_Studio/Detect-faces.svg";
import {useAIToolsContext} from "../../../../../../../../../../context/AIToolsProvider";
import {AITools} from "../../../../../../../../../../constant";
import './DetectFaceTrigger.scss';
import axiosInstance from "../../../../../../../../../../../../../../axiosInstance";
import {useADSContext} from "../../../../../../../../../../context/ADSProvider";

const DetectFaceTrigger = () => {
  const {userInfo, projectId} = useADSContext();
  const {
    firstSelectedImage,
    firstSelectedImageServerPath,

    secondSelectedImage,

    selectedAITools,

    setFirstBoundingBox,
    setFirstBoundingBoxSelectedIndexes,
    setSecondBoundingBox,
    setSecondBoundingBoxSelectedIndexes,
    setFirstSelectedImageServerPath,
    setSecondSelectedImageServerPath,
  } = useAIToolsContext();

  const [showBlink, setShowBlink] = useState(false);
  const [loading, setLoading] = useState(false);

  const {balance} = userInfo.userCredit || {};

  const storeData = (data) => {
    const currentFirstBoundingBox = data.imageInputFaces?.map(item => item.boundingBox)
    setFirstBoundingBox(currentFirstBoundingBox)
    setFirstSelectedImageServerPath(data.imageInputUrl)
    setFirstBoundingBoxSelectedIndexes(null)

    if (selectedAITools === AITools.SwapFace) {
      const currentSecondBoundingBox = data.imageSwapFaces?.map(item => item.boundingBox)
      setSecondBoundingBox(currentSecondBoundingBox)
      setSecondSelectedImageServerPath(data.imageSwapUrl)
      setSecondBoundingBoxSelectedIndexes(null)
    }
  }

  const handleDetectFace = () => {
    setShowBlink(false)
    setLoading(true)
    if (balance > 0) {
      let formData = new FormData();

      formData.append("projectId", projectId);

      if (firstSelectedImageServerPath) {
        formData.append("selectedImageUrl", firstSelectedImageServerPath);
      } else {
        formData.append("imageInputFile", firstSelectedImage);
      }

      if (selectedAITools === AITools.SwapFace) {
        formData.append("imageSwapFile", secondSelectedImage);
      }

      const fullUrl =  window.localStorage.getItem("BaseURL") +
        "/services/projectmanagement/api/products/detect-faces"

      axiosInstance.post(fullUrl, formData)
        .then((res) => storeData(res.data))
        .catch(console.error)
        .finally(() => {
          setLoading(false);
      })
    }
  }

  const showDetectFace = useMemo(() => {
    if (selectedAITools === AITools.SwapFace) {
      return !!firstSelectedImage && !!secondSelectedImage;
    } else if (selectedAITools === AITools.FaceCorrection) {
      return !!firstSelectedImage || !!firstSelectedImageServerPath;
    } else {
      return false
    }
  }, [firstSelectedImage, firstSelectedImageServerPath, secondSelectedImage, selectedAITools]);

  useEffect(() => {
    if (showDetectFace) {
      setShowBlink(true);
    }
  }, [showDetectFace])

  if (!showDetectFace) {
    return null;
  }

  return (
    <div
      className="detect-trigger"
      onClick={handleDetectFace}
    >
      {loading ? (
        <img className="loading" alt="" src={LoadingIcon}/>
      ) : (
        <>
          <img alt="" src={DetectFaces}/>
          {showBlink && <span className="blinking-popup">Detect face</span>}
        </>
      )}
    </div>
  );
};

export default DetectFaceTrigger;
